// extracted by mini-css-extract-plugin
export default {"GridContainer":"ppA4uwM4vkQba12jEfQy","Container":"gek5X0jCF7LLfHw5pcv9"};